import Footer from "../components/Footer/Footer";
import Login from "../components/Login/Login";
import NavBar from "../components/NavBar/NavBar";

import 'aos/dist/aos.css'; 


function Home() {
    
  return (
    <>
    <div className="page-container">

    <NavBar role="User Login"/>
   
     <div className="content-wrap">
     <Login title={'VEHICLE CHECK'}/>
     </div>

  

    <Footer/>
    </div>
    </>
  )   
;
}


export default Home;